module.exports = __webpack_public_path__ + "img/content4-9.c1235117.png";